import type { ChangeLogEntryDto } from "../types/ChangeLogEntryDto";
import type { ChangeLogEntryEntity } from "../types/ChangeLogEntryEntity";

export const ChangeLogEntryDtoToEntity = ({ ...rest }: Readonly<ChangeLogEntryDto>): ChangeLogEntryEntity => {
    return { ...rest };
};
